module.exports = __webpack_public_path__ + "static/media/Culvert-ico.aa9c61a3.svg";